import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'statusIcon',
  pure: true // This makes it a pure pipe for better performance
})
export class StatusIconPipe implements PipeTransform {
  transform(status: string): string {
    if (!status) {
      return 'fa fa-paper-plane';
    }
    
    switch (status.toLowerCase()) {
      case 'sent':
        return 'fa fa-paper-plane';
      case 'delivered':
        return 'fa fa-check';
      case 'read':
        return 'fa fa-check-double';
      default:
        return 'fa fa-paper-plane';
    }
  }
}
